import React from 'react';
import { InputNumber } from 'antd';
import { FH130 } from '../../../services/pwh203Api';
import LookupField from '../../../components/LookupField';

interface Props {
  formData: FH130;
  isEditing: boolean;
  getField: <K extends keyof FH130>(key: K) => FH130[K];
  setField: <K extends keyof FH130>(key: K, value: FH130[K]) => void;
}

const PAYMENT_MODES: Record<string, string> = {
  '1': '現金',
  '2': '押匯',
  '3': '支票',
  '4': '電匯',
  '5': '轉帳',
  '6': '沖暫借款',
  '7': '沖預收款',
  '8': '應付代付款',
};

const Tab1Main: React.FC<Props> = React.memo(({ formData, isEditing, getField, setField }) => {
  const isApproved = formData.fh130_80 === 'P';

  return (
    <div className="pwh203-form-grid">
      {isApproved && (
        <div className="pwh203-approved-badge">已核准</div>
      )}

      <div className="form-row">
        <label>沖帳單號</label>
        <input
          className="form-input"
          value={getField('fh130_01')}
          disabled
          readOnly
        />
        <label>核准狀態</label>
        <input
          className="form-input"
          value={formData.fh130_80 === 'P' ? '已核准' : '未核准'}
          disabled
          readOnly
        />
      </div>

      <div className="form-row">
        <label>沖帳日期 *</label>
        <input
          className="form-input"
          type="date"
          value={getField('fh130_11') ? String(getField('fh130_11')).substring(0, 10) : ''}
          onChange={(e) => setField('fh130_11', e.target.value ? e.target.value + 'T00:00:00Z' : null)}
          disabled={!isEditing}
        />
        <label>建立日期</label>
        <input
          className="form-input"
          type="date"
          value={getField('fh130_21') ? String(getField('fh130_21')).substring(0, 10) : ''}
          disabled
          readOnly
        />
      </div>

      <div className="form-row">
        <label>公司/員工 *</label>
        <LookupField
          lookupType="vendor"
          value={getField('fh130_15')}
          onChange={(v) => setField('fh130_15', v)}
          onCodeConfirm={(v) => setField('fh130_15', v)}
          disabled={!isEditing}
          maxLength={12}
          style={{ width: '100%' }}
        />
        <label>公司/員工類別</label>
        <input
          className="form-input"
          value={getField('fh130_14')}
          onChange={(e) => setField('fh130_14', e.target.value)}
          disabled={!isEditing}
          maxLength={1}
        />
      </div>

      <div className="form-row">
        <label>幣別 *</label>
        <LookupField
          lookupType="currency"
          value={getField('fh130_16')}
          onChange={(v) => setField('fh130_16', v.toUpperCase())}
          onCodeConfirm={(v) => setField('fh130_16', v.toUpperCase())}
          disabled={!isEditing}
          maxLength={3}
          style={{ width: '100%' }}
        />
        <label>匯率</label>
        <InputNumber
          className="form-input"
          value={Number(getField('fh130_17'))}
          precision={4}
          disabled
          readOnly
        />
      </div>

      <div className="form-row">
        <label>部門代號</label>
        <input
          className="form-input"
          value={getField('fh130_19')}
          onChange={(e) => setField('fh130_19', e.target.value)}
          disabled={!isEditing}
          maxLength={6}
        />
        <label>總項數</label>
        <input
          className="form-input"
          value={getField('fh130_20')}
          disabled
          readOnly
        />
      </div>

      <div className="form-row">
        <label>原幣沖帳總額</label>
        <InputNumber
          className="form-input amount-field"
          value={Number(getField('fh130_12'))}
          precision={2}
          formatter={v => v ? Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
          disabled
          readOnly
        />
        <label>原幣實付總額</label>
        <InputNumber
          className="form-input amount-field"
          value={Number(getField('fh130_18'))}
          precision={2}
          formatter={v => v ? Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
          disabled
          readOnly
        />
      </div>

      <div className="form-row">
        <label>付款方式說明</label>
        <div className="form-input readonly-display">
          {PAYMENT_MODES[formData.fh130_14] || '—'}
        </div>
      </div>
    </div>
  );
});

export default Tab1Main;
